import { render, staticRenderFns } from "./table-paginated.vue?vue&type=template&id=6ed4b09c"
import script from "./table-paginated.vue?vue&type=script&lang=js"
export * from "./table-paginated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports